module.exports = __webpack_public_path__ + "img/banner_02.e55ff4aa.jpg";